(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseNumberingRowDialogController', PurchaseNumberingRowDialogController);

    PurchaseNumberingRowDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchaseNumberingRow'];

    function PurchaseNumberingRowDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchaseNumberingRow) {
        var vm = this;
        vm.purchaseNumberingRow = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseNumberingRowUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchaseNumberingRow.id !== null) {
                PurchaseNumberingRow.update(vm.purchaseNumberingRow, onSaveSuccess, onSaveError);
            } else {
                PurchaseNumberingRow.save(vm.purchaseNumberingRow, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
